import { AziendeHero } from "@/components/aziende/AziendeHero";
import { HubOperativo } from "@/components/aziende/HubOperativo";
import { InsightsSection } from "@/components/aziende/InsightsSection";
import { SquadraDomani } from "@/components/aziende/SquadraDomani";
import { PercheProdigy } from "@/components/aziende/PercheProdigy";
import { ComeIniziare } from "@/components/aziende/ComeIniziare";
import { FinalCta } from "@/components/aziende/FinalCta";

export default function Aziende() {
  return (
    <main data-testid="aziende-page">
      <AziendeHero />
      <HubOperativo />
      <InsightsSection />
      <SquadraDomani />
      <PercheProdigy />
      <ComeIniziare />
      <FinalCta />
    </main>
  );
}
